
export enum CalendarView {
    Month = 1,
    Weekly = 2,
    Daily = 3,
    Agenda = 4
  }